import React from "react";

const MenuDrawerHeader = ({ isUserLogged }) => {
  return (
    <div style={styles.container}>
      <img src="/images/fullproof_logo_black.svg" alt="Fullproof" style={{ height: "40px" }} />
      <div
        style={{
          ...styles.subTitle,
          display: isUserLogged ? "flex" : "none",
        }}
      >
        For special offers and the best experience:
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 0",
  },
  subTitle: {
    fontSize: "1.1rem",
    color: "#000",
    marginTop: "20px",
    fontWeight: "500",
  },
};

export default MenuDrawerHeader;
